import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Days from '@/components/Days'
import Burn from '@/components/Burn'
import Submission from '@/components/Submission'
import HotStove from '@/components/HotStove'
// import Approval from '@/components/Approval'
// import About from '@/components/About'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/submission',
      name: 'Submission',
      component: Submission
    },
    {
      path: '/burnnn',
      name: 'Burn',
      component: Burn
    },
    {
      path: '/latest',
      name: 'HotStove',
      component: HotStove
    },
    // {
    //   path: '/approval',
    //   name: 'Approval',
    //   component: Approval
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About
    // },
    {
      path: '/days',
      name: 'Days',
      component: Days
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js